import React from "react";

import createNamespace from "services/language";
import Route from "components/common/History/Route";
import { WORKSPACES } from "utils/constants/routes";

const Index = React.lazy(() => import("./index"));
const Create = React.lazy(() => import("./create"));
const Details = React.lazy(() => import("./details"));

const namespace = "workspaces";

export default createNamespace({
  namespace,
  Component: function Main() {
    return (
      <>
        <Route exact path={WORKSPACES.ROOT} component={Index} />
        <Route exact path={WORKSPACES.CREATE_WORKSPACE} component={Create} />
        <Route
          exact
          path={WORKSPACES.WORKSPACE_DETAILS}
          component={(props) => {
            if (["overview", "usagecost"].includes(props.match?.params?.id)) {
              return null;
            }
            return <Details {...props} />;
          }}
        />
        <Route exact path={WORKSPACES.TAB_DETAILS} component={Details} />
      </>
    );
  },
});
